import { Box, Card, Typography } from "@mui/material";
import { UseMaterialColors } from "lib/hooks";
import { ContainmentCardStyle } from "lib/styles/card";

interface totalsSummaryCardProps {
	totalCount: number;
	totalUploaded: number;
	itemLabel: string;
}

export function TotalsSummaryCard({
	totalCount,
	totalUploaded,
	itemLabel,
}: totalsSummaryCardProps): React.JSX.Element {
	const materialColors = UseMaterialColors();

	return (
		<Card sx={ContainmentCardStyle()}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					gap: 3,
				}}
			>
				<Box sx={{ textAlign: "center", flex: 1 }}>
					<Typography
						variant="body2"
						fontWeight="bold"
						sx={{
							color: materialColors.onSurfaceVariant,
							mb: 0.5,
						}}
					>
						Total {itemLabel} Count
					</Typography>
					<Typography
						variant="h5"
						data-test-selector="total-serials-count"
						sx={{ color: materialColors.primary }}
					>
						{totalCount.String()}
					</Typography>
				</Box>
				<Box sx={{ textAlign: "center", flex: 1 }}>
					<Typography
						variant="body2"
						fontWeight="bold"
						sx={{
							color: materialColors.onSurfaceVariant,
							mb: 0.5,
						}}
					>
						Total {itemLabel}s Uploaded
					</Typography>
					<Typography
						variant="h5"
						data-test-selector="total-serials-uploaded"
						sx={{ color: materialColors.secondary }}
					>
						{totalUploaded.String()}
					</Typography>
				</Box>
			</Box>
			{totalUploaded > totalCount && (
				<Typography
					variant="caption"
					sx={{
						color: materialColors.error,
						mt: 2,
						textAlign: "right",
					}}
				>
					*Duplicate {itemLabel}s were found in the
					containment upload(s)
				</Typography>
			)}
		</Card>
	);
}
